import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from "@mui/icons-material/Add";
import {FileUploadProps} from "./types";
import {DragDropContainer, DragDropLabel, BoxNoMouseEvents} from "./FileUpload.styles";


export const FileUpload: React.FC<FileUploadProps> = ({
    accept = ".pdf, .doc, .docx, .txt",
    useDragDrop = true,
    hoverLabel = 'Click here or drag file to upload',
    dropLabel = 'Drop file here',
    width = '500px',
    height = '150px',
    backgroundColor = '#fff',
    onFilesSelect,
    onFilesDrop,
}) => {
    const [labelText, setLabelText] = React.useState<string>(hoverLabel)
    const [isDragOver, setIsDragOver] = React.useState<boolean>(false)
    const [isMouseOver, setIsMouseOver] = React.useState<boolean>(false)
    const stopDefaults = (e: React.DragEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }
    const dragEvents = {
        onMouseEnter: () => {
            setIsMouseOver(true)
        },
        onMouseLeave: () => {
            setIsMouseOver(false)
        },
        onDragEnter: (e: React.DragEvent) => {
            stopDefaults(e)
            setIsDragOver(true)
            setLabelText(dropLabel)
        },
        onDragLeave: (e: React.DragEvent) => {
            stopDefaults(e)
            setIsDragOver(false)
            setLabelText(hoverLabel)
        },
        onDragOver: stopDefaults,
        onDrop: (e: React.DragEvent<HTMLElement>) => {
            stopDefaults(e)
            setLabelText(hoverLabel)
            setIsDragOver(false)
            onFilesDrop(e)
        },
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onFilesSelect(e)
    }

    return (
        <Box width={width} height={height} sx={{ border: '1px dashed lightgrey' }}>
            <input
                id="file-upload"
                type="file"
                hidden
                accept={accept}
                onChange={handleChange}
            />

            {!useDragDrop && (
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        component="label"
                        htmlFor="file-upload"
                    >
                        <AddIcon /> Choose file...
                    </Button>
                </Box>
            )}
            {useDragDrop && (
            <DragDropLabel
                htmlFor="file-upload"
                {...dragEvents}
                isDragOver={isDragOver}
            >
                <DragDropContainer height={height} width={width}>
                    <BoxNoMouseEvents>
                        <CloudUploadIcon fontSize="large" />
                        <Typography>{labelText}</Typography>
                    </BoxNoMouseEvents>
                </DragDropContainer>
            </DragDropLabel>
            )}
        </Box>
    );
};